import { render, staticRenderFns } from "./DisabledHealthSecondPlate.vue?vue&type=template&id=08379330&"
import script from "./DisabledHealthSecondPlate.vue?vue&type=script&lang=js&"
export * from "./DisabledHealthSecondPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports